export default "/assets/images/cc-filter-room-03.1558923135bf1b94.webp";